export const AUTH_TOKEN_KEY = '@VivaVoz:token';
export const AUTH_USER_KEY = '@VivaVoz:user';
export const AUTH_SYNDICATE_KEY = '@VivaVoz:syndicate';

export function clearAuth(): void {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(AUTH_SYNDICATE_KEY);
}

export function redirectToLogin(): void {
  if (window.location.pathname !== '/') {
    window.location.replace('/');
  }
}

export function isTokenExpired(token: string | null): boolean {
  if (!token) return true;
  try {
    const [, payload] = token.split('.');
    if (!payload) return true;
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    if (typeof decoded.exp !== 'number') return false;
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}
